import gql from "graphql-tag";

export const MY_DOCUMENTS_GET_UPLOADERS = gql`
  query getMyDocumentsUploaders($contractCode: String!, $locale: String!) {
    getMyDocumentsUploaders(contractCode: $contractCode, locale: $locale) {
      name
      contract
    }
  }
`;
